import { Link } from 'react-router-dom';
import { HiMenuAlt3 } from "react-icons/hi";
import "./Sidebar.scss"
import { useState, useEffect } from 'react';
import ydlogo from "./megertu3.png"
import menu from './menu';
import SidebarItems from './SidebarItems';

const Sidebar = ({ children, isOpen: isOpenProp, toggle: toggleProp }) => {
  // ✅ Use internal state if no props passed from parent
  const [internalOpen, setInternalOpen] = useState(true);

  const isOpen = isOpenProp !== undefined ? isOpenProp : internalOpen;
  const toggle = toggleProp || (() => setInternalOpen(prev => !prev));
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  return (
    <div className="layout">

      {/* ── Desktop sidebar only ─────────────────────────────── */}
      {!isMobile && (
        <div
          className="sidebar1"
          style={{
            width:    isOpen ? "230px" : "60px",
            minWidth: isOpen ? "230px" : "60px",
          }}>
          <div className="top_section justify-content-md-between">
            <Link to="/">
              <img
                src={ydlogo} alt="ydlogo" width={100} height={70}
                style={{
                  paddingLeft: "10px",
                  display:     isOpen ? "block" : "none",
                  cursor:      "pointer",
                }}
              />
            </Link>
            <div className="bars" style={{ marginLeft: isOpen ? "80px" : "0px" }}>
              <HiMenuAlt3 onClick={toggle} size={23} style={{ cursor: "pointer" }} />
            </div>
          </div>
          <div className="menu">
            {menu.map((item, index) => (
              <SidebarItems key={index} item={item} isOpen={isOpen} />
            ))}
          </div>
        </div>
      )}

      {/* ── Main content ─────────────────────────────────────── */}
      <main>
        {children}
      </main>

    </div>
  );
};

export default Sidebar;